import { Modal, message } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useMemo } from "react"
import styled from "styled-components"

import { notifyParticipants } from "../../../../../../api/index"
import AppButton from "../../../../../_shared/components/AppButton/index"
import BottomSheet from "../../../../../_shared/components/BottomSheet"
import StyledAppInput from "../../../../../_shared/components/FormItems/AppInput"
import Editor from "../../../../../_shared/components/WYSIWYGEditor/index"
import { useStateValue } from "../../../../../_shared/context/AppStateStore"

// ----------------------------------------------------------------------------

function _EmailBottomSheet(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { open, onCancel, event } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------
    const [{ token }] = useStateValue()

    const [emailBody, setEmailBody] = useState("")
    const [emailSubject, setEmailSubject] = useState("")

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    async function sendMail() {
        const response = await notifyParticipants(
            emailBody,
            emailSubject,
            event?.id,
            token
        )
        console.log("repsonse", response)
        message.success("Email inviata con successo.")
    }

    function confirm() {
        Modal.confirm({
            cancelText: "Annulla",
            okText: "Coferma",
            content: "Sei sicuro di Voler inviare questa mail?",
            onOk: sendMail,
        })
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <BottomSheet
            open={open}
            className={props.className}
            onCancel={onCancel}
            title="Prenotazioni"
            snapPoint={90}
        >
            <h3>Invia mail a tutti i partecipanti</h3>
            <StyledAppInput
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                placeholder="Oggetto"
            />
            <Editor
                className="editor"
                value={emailBody}
                onChange={setEmailBody}
            />
            <AppButton onClick={confirm} className="button" uxType="primary">
                Invia mail
            </AppButton>
        </BottomSheet>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_EmailBottomSheet.propTypes = {
    className: PropTypes.string.isRequired,
    open: PropTypes.bool,
    onCancel: PropTypes.func,
    event: PropTypes.object,
}

_EmailBottomSheet.defaultProps = {}

// ----------------------------------------------------------------------------

const EmailBottomSheet = styled(_EmailBottomSheet)`
    & {
        h3 {
            font-family: Poppins-Bold;
        }
        .editor {
            margin: 20px 0px;
        }
        .button {
            /* margin: 20px 0px; */
        }
    }
`
// ----------------------------------------------------------------------------

export default EmailBottomSheet
